// Ajout des variables globales pour leafletParams et L
window.leafletParams = window.leafletParams || {};
window.L = window.L || undefined;

(function () {
    // Création de la carte (par défaut si pas de coordonnées)
    const defaultLat = 48.8566;
    const defaultLng = 2.3522;
    const zoomDefault = 7;

    if (typeof L !== 'undefined' && $('#map-region').length && mapInit !== 'undefined') {
        const centerLat = (mapInit && mapInit.lat) ? mapInit.lat : defaultLat;
        const centerLng = (mapInit && mapInit.lng) ? mapInit.lng : defaultLng;
        const templateUrlPath = (mapInit && mapInit.template_url_path) ? mapInit.template_url_path : '/';

        // Initialise la carte Leaflet
        const map = L.map('map-region').setView([centerLat, centerLng], zoomDefault);

        const icon = L.icon({
            iconUrl: templateUrlPath + '/img/marker.png',
            shadowUrl: null,
            iconSize: [40, 60],
            shadowSize: [0, 0]
        });

        // Tuiles de base
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        L.marker([centerLat, centerLng], { icon: icon }).addTo(map);
    }
})();